import { z } from 'zod';
import { DEPARTMENT_ROWS, MUNICIPALITY_ROWS } from './municipality-data.js';
export const DEPARTMENTS = DEPARTMENT_ROWS.map(([code, name]) => ({
    code,
    name,
}));
export const MUNICIPALITIES = MUNICIPALITY_ROWS.map(([code, name]) => ({
    code,
    departmentCode: code.slice(0, 2),
    name,
}));
const BY_CODE = new Map(MUNICIPALITIES.map((m) => [m.code, m]));
export const MunicipalityCodeSchema = z
    .string()
    .regex(/^\d{5}$/)
    .refine((code) => BY_CODE.has(code), { message: 'Municipio desconocido' })
    .meta({ id: 'MunicipalityCode', description: 'Código DANE de 5 dígitos.' });
export function findMunicipality(code) {
    return BY_CODE.get(code);
}
export function municipalitiesOf(departmentCode) {
    return MUNICIPALITIES.filter((m) => m.departmentCode === departmentCode);
}
/** Ciudades de cobertura del demo (`03-demo/02-datos-semilla.md` §2.1). */
export const DEMO_COVERAGE_MUNICIPALITIES = {
    BOGOTA: '11001',
    SOACHA: '25754',
    MEDELLIN: '05001',
    CALI: '76001',
    BUCARAMANGA: '68001',
};
//# sourceMappingURL=municipalities.js.map